import { Routes, Route, Navigate } from "react-router-dom";
import Home from "../pages/Home";
import Register from "../pages/Register";
import Dashboard from "pages/Dashboard";
import AdminDashboard from "pages/AdminDashboard";
import BusinessPortal from "pages/BusinessPortal";
import OrganizationsAdmin from "pages/OrganizationsAdmin";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/register" element={<Register />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="*" element={<Navigate to="/" />} />
      <Route path="/business-portal" element={<BusinessPortal />} />
      <Route path="/admin/organizations" element={<OrganizationsAdmin />} />
    </Routes>
  );
}
